const React = require("react");
const T = React.PropTypes;

require("./SurveyLoadError.less");

const ErrorType = require("~/types/Error.js").PropType;

const MajorError = require("../MajorError/MajorError.jsx");

const SurveyLoadError = React.createClass({
    propTypes: {
        Error: ErrorType
    },
    render() {
        return (<div className="cs-SurveyLoadError">
            <h2>There was a problem loading the survey.</h2>
            <h3>
                First thing to do is try reloading this page.
            </h3>
            <h3>
                If that doesn't work, please contact Support Services.
            </h3>
            <MajorError Error={this.props.Error} />
        </div>);
    }
});

module.exports = SurveyLoadError;


// WEBPACK FOOTER //
// ./src/components/SurveyLoadError/SurveyLoadError.jsx